<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32">
    <g id="Gruppe_95" data-name="Gruppe 95" transform="translate(-307 -280)">
      <rect id="Rechteck_7" data-name="Rechteck 7" width="32" height="32" rx="16" transform="translate(307 280)" fill="#939393"/>
      <path id="Pfad_70" data-name="Pfad 70" d="M844.647,681.967v-9.551a.638.638,0,0,0-1.276,0v9.551a.638.638,0,0,0,1.276,0Zm-4.695.638a.638.638,0,0,0,.638-.638v-9.551a.638.638,0,0,0-1.276,0v9.551A.638.638,0,0,0,839.952,682.605Zm8.855-12.9h-3.69a3.14,3.14,0,0,0-6.274,0h-3.69a.638.638,0,0,0,0,1.276h13.653a.638.638,0,1,0,0-1.276Zm-8.685,0a1.864,1.864,0,0,1,3.717,0Zm7.756,2.071a.618.618,0,0,0-.618.618v9.035a2.735,2.735,0,0,1-2.732,2.732h-5.1a2.735,2.735,0,0,1-2.732-2.732V672.4a.618.618,0,1,0-1.236,0v9.035a3.973,3.973,0,0,0,3.968,3.968h5.1a3.973,3.973,0,0,0,3.968-3.968V672.4A.618.618,0,0,0,847.878,671.778Z" transform="translate(-519.061 -380.304)" fill="#fff"/>
    </g>
  </svg>
</template>

<script>
export default {
name: "trashCan"
}
</script>

<style scoped>

</style>